import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class ProductConceptService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<ProductConcept[]> => {
    return this.apiHttp.get<ProductConcept[]>("productconcepts");
  };

  public get = (id: number): Observable<ProductConcept> => {
    return this.apiHttp.get<ProductConcept>(`productconcepts/${id}`);
  };
}

export interface ProductConcept {
  id: number;
  name: string;
  isActive: boolean;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/product-concept.service.ts